module.exports = __webpack_public_path__ + "assets/img/haiwaicang.d7638ab0.png";